import React, { Component } from 'react'
import { Link, Redirect } from 'react-router-dom'
import { FormattedMessage, injectIntl } from 'react-intl'
import { CircularProgress } from '@material-ui/core'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import LocaleFormat from '../../commons/utils/LocaleFormat.js'
import Security from '../../commons/security/Security.js'
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'
import PeriodoPresupuestarioPresupuestoGrid from './PeriodoPresupuestarioPresupuestoGrid.jsx'

const KPI_CONFIG = [
    { key: 'asignado',     colorClass: 'success', icon: 'la la-dollar',       labelId: 'periodoPresupuestario.kpi.asignado',     labelDefault: 'Presupuesto asignado' },
    { key: 'distribuido',  colorClass: 'primary', icon: 'la la-share-alt',    labelId: 'periodoPresupuestario.kpi.distribuido',  labelDefault: 'Distribuido' },
    { key: 'restante',     colorClass: 'info',    icon: 'la la-pie-chart',    labelId: 'periodoPresupuestario.kpi.restante',     labelDefault: 'Restante' },
    { key: 'comprometido', colorClass: 'warning', icon: 'fa fa-clock-o',      labelId: 'periodoPresupuestario.kpi.comprometido', labelDefault: 'Comprometido' },
    { key: 'consumido',    colorClass: 'danger',  icon: 'fa fa-check-circle', labelId: 'periodoPresupuestario.kpi.consumido',    labelDefault: 'Consumido' },
]

class PeriodoPresupuestarioRegionDetalle extends Component {
    constructor(props) {
        super(props)
        this.ajaxHandler = new AjaxHandler()
        this.state = {
            kpis:                  { asignado: 0, distribuido: 0, restante: 0, comprometido: 0, consumido: 0 },
            loading:               true,
            porcentaje:            ConfigBusiness.get('periodoPresupuestario.porcentajeCorte'),
            nombre:                '',
            redirectTo:            null,
            showModalSubregiones:  false,
            loadingSubregiones:    false,
            subregionesDetalle:    [],
            filtroSubregion:       '',
        }
        this.handleVerSubregiones = this.handleVerSubregiones.bind(this)
    }

    componentWillMount() {
        if (Security.hasPermission('PERIODO_PRESUPUESTARIO_REGIONES_VER')) {
            this.ajaxHandler.subscribe(this)
            this.loadData()
        } else {
            this.setState({ redirectTo: '/error' })
        }
    }

    componentWillUnmount() {
        this.ajaxHandler.unsubscribe()
    }

    loadData() {
        var id = this.props.match.params.id
        var metadataPromise = this.ajaxHandler.getJson('/presupuestos/resumen-regiones?soloActivo=false')
            .then(function(data) {
                if (!data || !data.regiones) return
                var region = data.regiones.find(function(r) { return String(r.id) === String(id) })
                if (region) {
                    this.setState({ nombre: region.nombre })
                }
            }.bind(this))
        var kpisPromise = this.ajaxHandler.getJson('/presupuestos/regiones/' + id + '/kpis')
            .then(function(data) {
                if (!data) return
                this.setState({
                    kpis: {
                        asignado:     data.asignado,
                        distribuido:  data.distribuido,
                        restante:     data.asignado - data.distribuido,
                        comprometido: data.comprometido,
                        consumido:    data.consumido,
                    },
                })
            }.bind(this))
        Promise.all([metadataPromise, kpisPromise])
            .then(function() { this.setState({ loading: false }) }.bind(this))
    }

    formatCurrency(value) {
        return new Intl.NumberFormat(LocaleFormat.getNumberLocale(), { style: 'currency', currency: 'ARS' }).format(value || 0)
    }

    getIconColor(disponible, asignado) {
        if (asignado === 0 && disponible === 0) return 'gray'
        const pct = (disponible / asignado) * 100
        if (pct === 100) return '#474789'
        if (pct >= this.state.porcentaje) return '#28D094'
        if (pct > 0) return '#F1EA7F'
        return '#FF4961'
    }

    calcPct(value, base) {
        if (!base || base === 0) return 0
        return Math.min(100, Math.round((value / base) * 100))
    }

    refreshKpis() {
        var id = this.props.match.params.id
        this.ajaxHandler.getJson('/presupuestos/regiones/' + id + '/kpis')
            .then(function(data) {
                if (!data) return
                this.setState({
                    kpis: {
                        asignado:     data.asignado,
                        distribuido:  data.distribuido,
                        restante:     data.asignado - data.distribuido,
                        comprometido: data.comprometido,
                        consumido:    data.consumido,
                    },
                })
            }.bind(this))
    }

    handleVerSubregiones() {
        var id = this.props.match.params.id
        this.setState({ showModalSubregiones: true, loadingSubregiones: true, filtroSubregion: '' })
        this.ajaxHandler.getJson('/presupuestos/resumen-subregiones?soloActivo=false&regionId=' + id)
            .then(function(data) {
                if (!data || !data.subregiones) return
                var detalle = data.subregiones
                    .map(function(s) { return Object.assign({}, s, { restante: s.asignado - s.distribuido }) })
                this.setState({ subregionesDetalle: detalle })
            }.bind(this))
            .finally(function() { this.setState({ loadingSubregiones: false }) }.bind(this))
    }

    getFilteredSubregionesDetalle() {
        var filtro = this.state.filtroSubregion.toLowerCase()
        if (!filtro) return this.state.subregionesDetalle
        return this.state.subregionesDetalle.filter(function(s) { return s.nombre.toLowerCase().indexOf(filtro) !== -1 })
    }

    kpiSubtitle(key, kpis) {
        var intl = this.props.intl
        if (key === 'asignado')     return intl.formatMessage({ id: 'periodoPresupuestario.toggle.todos', defaultMessage: 'Todos los períodos' })
        if (key === 'distribuido')  return intl.formatMessage({ id: 'periodoPresupuestario.kpi.subtitle.distribuido', defaultMessage: '{pct}% del total' }, { pct: this.calcPct(kpis.distribuido, kpis.asignado) })
        if (key === 'comprometido') return intl.formatMessage({ id: 'periodoPresupuestario.kpi.subtitle.comprometido', defaultMessage: 'Tickets aprobados' })
        if (key === 'consumido')    return intl.formatMessage({ id: 'periodoPresupuestario.kpi.subtitle.consumido', defaultMessage: 'Tickets cerrados' })
        if (key === 'restante')     return intl.formatMessage({ id: 'periodoPresupuestario.kpi.subtitle.distribuido', defaultMessage: '{pct}% del total' }, { pct: this.calcPct(kpis.restante, kpis.asignado) })
        return ''
    }

    render() {
        const { kpis, loading } = this.state
        const id     = this.props.match.params.id
        const action = this.props.action
        const baseUrl = this.props.match.url.replace('/' + id + (action === 'EDIT' ? '/edit' : ''), '')

        if (this.state.redirectTo) return <Redirect push to={this.state.redirectTo} />

        return (
            <React.Fragment>
                {/* Header panel */}
                {this.state.nombre && (
                    <div className="row mt-1 mb-2">
                        <div className="col-12">
                            <div style={{ borderLeft: '4px solid #1E9FF2', backgroundColor: '#fff', padding: '10px 16px', borderRadius: '4px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <h4 className="content-header-title mb-0">
                                    <Link to={baseUrl}><FormattedMessage id="periodoPresupuestario.grid.region" defaultMessage="Región" /></Link>
                                    {' '}<strong>{this.state.nombre}</strong>
                                </h4>
                                <button className="btn btn-primary" onClick={this.handleVerSubregiones}>
                                    <i className="fa fa-search mr-1"></i>
                                    <FormattedMessage id="periodoPresupuestario.region.ver_subregiones" defaultMessage="Ver subregiones" />
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* KPI Cards */}
                <div className="row">
                    {KPI_CONFIG.map(kpi => (
                        <div key={kpi.key} className="col">
                            <div className="card pull-up">
                                <div className="card-content">
                                    <div className="card-body">
                                        <div className="media d-flex">
                                            <div className="media-body text-left">
                                                <h3 className={'text-' + kpi.colorClass + ' font-weight-500'}>
                                                    {loading ? <CircularProgress size={22} /> : this.formatCurrency(kpis[kpi.key])}
                                                </h3>
                                                <h6>
                                                    <FormattedMessage id={kpi.labelId} defaultMessage={kpi.labelDefault} />
                                                </h6>
                                                <small className="text-muted">{this.kpiSubtitle(kpi.key, kpis)}</small>
                                            </div>
                                            <div>
                                                <i className={kpi.icon + ' text-' + kpi.colorClass + ' font-large-2 float-right'}></i>
                                            </div>
                                        </div>
                                        <div className="progress progress-sm mt-1 mb-0 box-shadow-2">
                                            <div
                                                className={'progress-bar bg-gradient-x-' + kpi.colorClass}
                                                role="progressbar"
                                                style={{ width: this.calcPct(kpis[kpi.key], kpis.asignado) + '%' }}
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Modal Subregiones */}
                {this.state.showModalSubregiones && (
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-lg" role="document">
                            <div className="modal-content" style={{ borderRadius: '12px', overflow: 'hidden' }}>
                                <div className="modal-header bg-fleet">
                                    <h5 className="modal-title text-white">
                                        <FormattedMessage id="periodoPresupuestario.region.subregiones" defaultMessage="Subregiones" />
                                    </h5>
                                    <button type="button" className="close text-white" onClick={() => this.setState({ showModalSubregiones: false })}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="mb-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder={this.props.intl.formatMessage({ id: 'periodoPresupuestario.modal.filtrar', defaultMessage: 'Filtrar...' })}
                                            value={this.state.filtroSubregion}
                                            onChange={e => this.setState({ filtroSubregion: e.target.value })}
                                        />
                                    </div>
                                    {this.state.loadingSubregiones ? (
                                        <div className="text-center py-3"><CircularProgress /></div>
                                    ) : this.getFilteredSubregionesDetalle().length === 0 ? (
                                        <p className="text-muted text-center">
                                            <FormattedMessage id="periodoPresupuestario.region.sin_subregiones" defaultMessage="Sin subregiones asociadas" />
                                        </p>
                                    ) : (
                                        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                        <table className="table table-sm table-hover">
                                            <thead style={{ backgroundColor: '#241b3e', color: '#fff' }}>
                                                <tr>
                                                    <th></th>
                                                    <th><FormattedMessage id="periodoPresupuestario.modal.nombre" defaultMessage="Nombre" /></th>
                                                    <th className="text-right"><FormattedMessage id="periodoPresupuestario.kpi.asignado" defaultMessage="Asignado" /></th>
                                                    <th className="text-right"><FormattedMessage id="periodoPresupuestario.kpi.distribuido" defaultMessage="Distribuido" /></th>
                                                    <th className="text-right"><FormattedMessage id="periodoPresupuestario.kpi.comprometido" defaultMessage="Comprometido" /></th>
                                                    <th className="text-right"><FormattedMessage id="periodoPresupuestario.kpi.consumido" defaultMessage="Consumido" /></th>
                                                    <th className="text-right"><FormattedMessage id="periodoPresupuestario.kpi.restante" defaultMessage="Restante" /></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.getFilteredSubregionesDetalle().map(function(s) {
                                                    return (
                                                        <tr key={s.id}>
                                                            <td><i className="fa fa-circle" style={{ color: this.getIconColor(s.restante, s.asignado), fontSize: '1rem' }}></i></td>
                                                            <td><Link to={'/periodoPresupuestario/subregiones/' + s.id + (action === 'EDIT' ? '/edit' : '')} target="_blank" rel="noopener noreferrer">{s.nombre}</Link></td>
                                                            <td className="text-right">{this.formatCurrency(s.asignado)}</td>
                                                            <td className="text-right">{this.formatCurrency(s.distribuido)}</td>
                                                            <td className="text-right">{this.formatCurrency(s.comprometido)}</td>
                                                            <td className="text-right">{this.formatCurrency(s.consumido)}</td>
                                                            <td className="text-right">{this.formatCurrency(s.restante)}</td>
                                                        </tr>
                                                    )
                                                }.bind(this))}
                                            </tbody>
                                        </table>
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-danger" onClick={() => this.setState({ showModalSubregiones: false })}>
                                        <FormattedMessage id="Cerrar" defaultMessage="Cerrar" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* PresupuestoGrid existente */}
                {Security.hasPermission('PERIODO_PRESUPUESTARIO_REGIONES_VER') && (
                    <div className="row">
                        <div className="col-12">
                            <PeriodoPresupuestarioPresupuestoGrid
                                modulo="regiones"
                                id={id}
                                presupuestable="region"
                                editar={Security.hasPermission('PERIODO_PRESUPUESTARIO_REGIONES_MODIFICAR') && action === 'EDIT'}
                                setLoading={(val) => this.setState({ loading: val })}
                                onPresupuestoUpdated={() => this.refreshKpis()}
                            />
                        </div>
                    </div>
                )}
            </React.Fragment>
        )
    }
}

export default injectIntl(PeriodoPresupuestarioRegionDetalle)
